import Vue from 'vue'
import axios from 'axios'
import Vuex from 'vuex'
import moment from 'moment';
import VueSuggestion from 'vue-suggestion';
import VueSafeHTML from 'vue-safe-html';
import PerfectScrollbar from 'vue2-perfect-scrollbar';

import NewTreeview from '@/front/components/NewTreeview';
import TreeviewItem from '@/front/components/NewTreeviewItem';


import helper from '@/helper'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

moment.locale('fr');
Vue.use(Vuex)
Vue.use(VueSafeHTML)
Vue.use(VueSuggestion)
Vue.use(PerfectScrollbar)

Vue.component('NewTreeview', NewTreeview);
Vue.component('Treeview-item', TreeviewItem);
Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    selectedNotices: [],
    selectAll: false,
    selectAllQuery: false,
    config: [],
    cart: [],
    searchHistory: [],
    noticeCollections: []
  },
  mutations: {
    selectNotice (state, noticeId) {
      state.selectAll = false
      state.selectedNotices.push(noticeId)
      state.selectedNotices = [ ...new Set(state.selectedNotices) ]
    },
    unselectNotice (state, noticeId) {
      state.selectAll = false
      state.selectedNotices = state.selectedNotices.filter(item => item !== noticeId)
    },
    unselectAll (state) {
      state.selectAll = false
      state.selectedNotices = []
    },
    selectAll (state, value) {
      state.selectAll = value
    },
    setConfig (state, value) {
      state.config = value
    },
    setSearchHistory (state, value) {
      state.searchHistory = value
    },
    addToSearchHistory (state, value) {
      if(!helper.containUrl(value, state.searchHistory)){
        state.searchHistory.push(value)
        if(state.searchHistory.length > 10){
          state.searchHistory.shift();
        }
        localStorage.setItem('search_history', JSON.stringify(state.searchHistory));
      }
    },
    setCart (state, value) {
      state.cart = value
    },
    updateCart (state, value) {
      state.cart = value
      localStorage.setItem('cart', JSON.stringify(value));
      if(window.Cart) window.CartService.refresh();
    },
    addToCart (state, value) {
      if(state.cart.indexOf(value) === -1){
        state.cart.push(value)
        localStorage.setItem('cart', JSON.stringify(state.cart));
      }
      if(window.Cart) window.CartService.refresh();
    },
    removeFromCart (state, value) {
      state.cart = helper.arrayRemove(state.cart, value)
      localStorage.setItem('cart', JSON.stringify(state.cart));
      if(window.Cart) window.CartService.refresh();
    },
    setNoticeCollections (state, value) {
      state.noticeCollections = value
    },
  }
})

axios.defaults.headers.common['Accept-Language'] = document.documentElement.lang

new Vue({
  vuetify,
  store: store,
  render: h => h(App)
}).$mount('#app-vue')
